// extracted by mini-css-extract-plugin
var _1 = "ActivityLabel_attachmentScope__BLcJA";
var _2 = "ActivityLabel_boardScope__XunfK";
var _3 = "ActivityLabel_cardScope__NNE17";
var _4 = "ActivityLabel_commentScope__sTK+W";
var _5 = "ActivityLabel_instanceScope__4QLwx";
var _6 = "ActivityLabel_listScope__d+fVQ";
var _7 = "ActivityLabel_projectScope__Shyhi";
var _8 = "ActivityLabel_scope__+usB+";
var _9 = "ActivityLabel_scopeText__n0vko";
var _a = "ActivityLabel_taskScope__haiJ-";
var _b = "ActivityLabel_userScope__RuNdd";
export { _1 as "attachmentScope", _2 as "boardScope", _3 as "cardScope", _4 as "commentScope", _5 as "instanceScope", _6 as "listScope", _7 as "projectScope", _8 as "scope", _9 as "scopeText", _a as "taskScope", _b as "userScope" }
